<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
  data: () => ({
    active: false,
    options: [],
  }),
  methods: {
    handlerClick() {
      this.active = true;
    },
    handlerAdd(value) {
      this.$emit('add', value);
    },
  },
  mounted() {
    this.module.init()
      .then((opt) => {
        this.options = opt;
      });
  },
};
</script>
<template>
  <BtnPrimary
    @click="handlerClick"
  >
    Добавить услугу
    <DialogSelect
      title="Добавление услуги"
      :active.sync="active"
      :options="options"
      :loading="module.loading"
      @input="handlerAdd"
    ></DialogSelect>
  </BtnPrimary>
</template>
<style lang="scss">

</style>
